<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border" :disabled="loading">
        <v-card-text>
          <v-form ref="formBusca">
            <v-row dense>
              <v-col cols="12" sm="12" md="4">
                <SelectEmpresa
                  @onChanged="form.empresaPrincipal = $event"
                  :multiple="true"
                  :validate="false"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  v-model="form.cpf"
                  label="CPF do usuário"
                  v-mask="'###.###.###-##'"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">

                <v-select
                  v-model="form.grupoPrincipal"
                  :items="['GrupoCometa', 'GrupoDemostracao']"
                  label="Grupo principal"
                  clearable
                  @click:clear="clearGrupo()"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-row justify="center">
                  <v-btn
                    outlined
                    color="blue darken-2"
                    rounded
                    dark
                    depressed
                    small
                    @click="buscar()"
                  >
                    <v-icon left>mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :search="table.search"
            :loading="loading"
            :loading-text="'Carregando...'"
          >
            <template v-slot:top>
              <v-row dense>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="table.search"
                    label="Procurar..."
                    prepend-inner-icon="mdi-magnify"
                  />
                </v-col>
              </v-row>
            </template>

            <template v-slot:[`item.cpf`]="{ item }">
              {{ $functions.formatCpf(item.cpf) }}
            </template>

            <template v-slot:[`item.telefone`]="{ item }">
              {{ item.telefone }}
            </template>

            <template v-slot:[`item.empresaPrincipal`]="{ item }">
              {{ bucarApelidoEmpresa(item.empresaPrincipal) }}
            </template>

            <template v-slot:[`item.grupoPrincipal`]="{ item }">
            {{ item.grupoPrincipal }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                v-if="$ability.can('Editar', 'Usuarios')"
                title="Editar"
                color="transparent"
                small
                fab
                depressed
                @click="$refs.DialogEditarUsuario.show({ ...item })"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                v-if="$ability.can('Vincular Empresa', 'Usuarios')"
                title="Vincular a Empresa e Grupo principal"
                color="transparent"
                small
                fab
                depressed
                @click="$refs.DialogVincularUsuario.show({ ...item })"
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
              <v-btn
                v-if="$ability.can('Criar Colaborador', 'Usuarios')"
                title="Criar cadastro de colaborador"
                color="transparent"
                small
                fab
                depressed
                @click="criarColaborador(item)"
              >
                <v-icon>mdi-account-convert</v-icon>
              </v-btn>

              <v-btn
                v-if="$ability.can('Editar', 'Usuarios')"
                title="Deletar colaborador"
                color="transparent"
                small
                fab
                depressed
                @click="deletarColaborador(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <DialogEditarUsuario ref="DialogEditarUsuario" @update="buscar()" />
    <DialogVincularUsuario ref="DialogVincularUsuario" @update="buscar()" />
  </v-row>
</template>

<script>
import Colaboradores from "@/services/colaboradores";
import Usuarios from "@/services/usuarios";
import { mapGetters } from "vuex";

export default {
  name: "Usuarios",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogEditarUsuario: () => import("./components/DialogEditarUsuario"),
    DialogVincularUsuario: () => import("./components/DialogVincularUsuario")
  },

  data() {
    return {
      loading: false,

      form: {
        empresaPrincipal: [],
        cpf: "",
        grupoPrincipal: ""
      },

      table: {
        search: "",
        headers: [
          {
            text: "Nome",
            value: "nome"
          },
          {
            text: "Apelido",
            value: "apelido"
          },
          {
            text: "CPF",
            value: "cpf"
          },
          {
            text: "E-mail",
            value: "email"
          },
          {
            text: "Telefone",
            value: "telefone"
          },
          {
            text: "Empresa Principal",
            value: "empresaPrincipal"
          },
          {
            text: "Grupo Principal",
            value: "grupoPrincipal"
          },
          {
            text: "Papel",
            value: "papel"
          },
          {
            text: "",
            value: "actions"
          }
        ],
        data: []
      }
    };
  },

  computed: {
    ...mapGetters(["getEmpresas"])
  },

  methods: {
    clearGrupo(){
      this.form.grupoPrincipal =''
    },
    async buscar() {
      try {
        this.loading = true;
        this.table.data = [];
        let usuarios = await new Usuarios().list(this.form);
        this.table.data = usuarios;
      } catch (error) {
        console.error(error);
        this.$swal.error(error);
      } finally {
        this.loading = false;
      }
    },

    bucarApelidoEmpresa(value) {
      return (
        this.getEmpresas.find(item => {
          return item.cnpj == value;
        })?.apelido || "Não Encontrado"
      );
    },

    async criarColaborador(usuario) {
      if (!usuario.empresaPrincipal) {
        this.$swal.warning("", "Vincule a uma empresa principal");
        return;
      }
      if (!usuario.grupoPrincipal) {
        this.$swal.warning("", "Vincule a um grupo principal");
        return;
      }

      try {
        this.$loading.setLoading(true, "Cadastrando...");
        let colaborador = await new Colaboradores().getById(usuario.cpf);
        if (colaborador) {
          this.$swal.warning("", "Usuário já possui cadastro de colaborador");
          return;
        }

        await new Colaboradores().createByUser(usuario);
      } catch (error) {
        console.error(error);
        this.$swal.error(error);
      } finally {
        this.$loading.setLoading(false);
      }
    },

    async deletarColaborador(usuario) {
      let texto = "Deseja Deletar Colaborador?";
      this.$swal.confirm(texto).then(async () => {
        try {
          await new Usuarios().delete(usuario.cpf);
          await this.buscar();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao deletar colaborador");
          return Promise.reject(error);
        }
      });
    }
  }
};
</script>
